import { createFileRoute } from "@tanstack/react-router";

import { PaymentOrderDetail } from "../payment_orders/PaymentOrderDetail";
import { paymentOrderDetailQueryOptions } from "../payment_orders/queries";

export const Route = createFileRoute("/_auth/payment-orders/$emailId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      paymentOrderDetailQueryOptions(params.emailId),
    ),
  component: PaymentOrderDetailRoute,
});

function PaymentOrderDetailRoute() {
  const { emailId } = Route.useParams();
  return <PaymentOrderDetail emailId={emailId} />;
}
